<template>
  <div>
    <Section
      v-for="section in sections"
      :key="section.id"
      :section="section"
      :currentTime="currentTime"
      @seek-to="$emit('seek-to', $event)"
    />
  </div>
</template>

<script>
import Section from './Section';
import orderBy from 'lodash/orderBy';

export default {
  components: { Section },

  props: {
    stream: Object,
    currentTime: Number
  },

  computed: {
    sections() {
      return orderBy(this.stream.sections, 'position', 'asc');
    }
  }
};
</script>
